var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2PActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3055 18.9195C20.36 18.9267 20.4144 18.9341 20.4688 18.9417L20.7423 18.9801C21.9331 19.1472 22.9986 18.2396 22.9986 17.058V16.1562C22.9986 15.3112 22.4577 14.5573 21.6475 14.2731C20.7115 13.9447 19.7451 13.7309 18.7696 13.6317C19.7875 14.3676 20.4188 15.5593 20.4188 16.8594V17.979C20.4188 18.3042 20.3795 18.619 20.3055 18.9195ZM16.1797 12.432C16.5853 12.5995 17.0309 12.6921 17.4986 12.6921C19.3799 12.6921 20.905 11.194 20.905 9.34603C20.905 7.49807 19.3799 6 17.4986 6C17.4428 6 17.3874 6.00131 17.3323 6.00391C17.6744 6.73253 17.8656 7.54606 17.8656 8.40426C17.8656 9.98076 17.2204 11.4066 16.1797 12.432Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07338 18.9195C4.01893 18.9267 3.9645 18.9341 3.91009 18.9417L3.63659 18.9801C2.44576 19.1472 1.38035 18.2396 1.38035 17.058V16.1562C1.38035 15.3112 1.92117 14.5573 2.73136 14.2731C3.66742 13.9447 4.63378 13.7309 5.6093 13.6317C4.59142 14.3676 3.96008 15.5593 3.96008 16.8594V17.979C3.96008 18.3042 3.99943 18.619 4.07338 18.9195ZM8.19922 12.432C7.79357 12.5995 7.34796 12.6921 6.88035 12.6921C4.99904 12.6921 3.47393 11.194 3.47393 9.34603C3.47393 7.49807 4.99904 6 6.88035 6C6.93609 6 6.99151 6.00131 7.04659 6.00391C6.70447 6.73253 6.51328 7.54606 6.51328 8.40426C6.51328 9.98076 7.15848 11.4066 8.19922 12.432Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3656 8.40426C16.3656 6.10992 14.5057 4.25 12.2113 4.25C9.91702 4.25 8.05709 6.10992 8.05709 8.40426C8.05709 10.6986 9.91702 12.5585 12.2113 12.5585C14.5057 12.5585 16.3656 10.6986 16.3656 8.40426Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15152 14.5215C10.4235 13.3529 13.9992 13.3529 17.2712 14.5215C18.2592 14.8743 18.9188 15.8103 18.9188 16.8594V17.979C18.9188 19.446 17.6195 20.5729 16.1672 20.3654L15.8337 20.3178C13.431 19.9745 10.9917 19.9745 8.58902 20.3178L8.25547 20.3654C6.80322 20.5729 5.50391 19.446 5.50391 17.979V16.8594C5.50391 15.8103 6.16346 14.8743 7.15152 14.5215Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2PActive);
export default __webpack_public_path__ + "static/media/p2p-active.bc68d336e515b3ace16329bb94cdfc21.svg";
export { ForwardRef as ReactComponent };